import { render, staticRenderFns } from "./Comhome.vue?vue&type=template&id=ed0dda1a&scoped=true&"
import script from "./Comhome.vue?vue&type=script&lang=js&"
export * from "./Comhome.vue?vue&type=script&lang=js&"
import style0 from "./Comhome.vue?vue&type=style&index=0&id=ed0dda1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0dda1a",
  null
  
)

export default component.exports